import { createContext } from "react";
import { IContextStore } from "../interfaces/ContextStore.interface";

const ContextStore = createContext<{contextStore: IContextStore, setContextStore: Function}>({
    contextStore: {} as IContextStore, 
    setContextStore: () => {}
});

export default ContextStore;